<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    showDetail: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onEmitClose() {
      this.$emit('close')
    },
    onEmitEdit() {
      this.$emit('edit', this.data)
    },
    onEmitView() {
      this.$emit('view', this.data)
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.inner" @click="onEmitView">
      <el-avatar :src="data.avatar" :size="100"></el-avatar>

      <h5>{{data.name}}</h5>
      <div :class="$style.title">{{data.title}}</div>
      <template v-if="showDetail">
        <p>{{`${data.phoneCode} ${data.phoneNumber}`}}</p>
        <p>{{data.description}}</p>
      </template>
    </div>
    <el-button v-if="showDetail" @click="onEmitClose">關閉</el-button>
    <el-button type="primary" plain @click="onEmitEdit">編輯</el-button>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.container {
  text-align: center;
}
.inner {
  margin-bottom: 15px;
}
.title {
  color: $color-text-secondary;
}
</style>
